import React, { useContext } from "react";
import { ProfileContext } from "../context/ProfileContext";
import { Outlet, NavLink } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Logo from "../components/Logo";
import Dropdown from "react-bootstrap/Dropdown";

const Layout = () => {
	const [profile] = useContext(ProfileContext);

	const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
		<a
			href=""
			ref={ref}
			onClick={(e) => {
				e.preventDefault();
				onClick(e);
			}}
			className="header-user-dropdown text-sm flex-row-left"
		>
			{children}
		</a>
	));

	return (
		<>
			<Toaster
				position="bottom-right"
				toastOptions={{ className: "snackbar-container" }}
			/>
			<div className="main-nav bg-white">
				<div className="main-nav-header flex-row-left full">
					<Logo />
				</div>
				<div className="main-nav-body">
					<NavLink
						to="/logs"
						className="main-nav-item opacity-5 flex-row-left full"
					>
						<i className="nav-icon ri-file-list-2-line"></i>
						<span className="text-medium-gotham text-sm">Logs</span>
					</NavLink>
					<NavLink
						to="/announcements"
						className="main-nav-item opacity-5 flex-row-left full"
					>
						<i className="nav-icon ri-megaphone-line"></i>
						<span className="text-medium-gotham text-sm">Announcements</span>
					</NavLink>
					<NavLink
						to="/students"
						className="main-nav-item opacity-5 flex-row-left full"
					>
						<i className="nav-icon ri-graduation-cap-line"></i>
						<span className="text-medium-gotham text-sm">Students</span>
					</NavLink>
					<NavLink
						to="/personnel"
						className="main-nav-item opacity-5 flex-row-left full"
					>
						<i className="nav-icon ri-group-line"></i>
						<span className="text-medium-gotham text-sm">Personnel</span>
					</NavLink>
					<NavLink
						to="/devices"
						className="main-nav-item opacity-5 flex-row-left full"
					>
						<i className="nav-icon ri-computer-line"></i>
						<span className="text-medium-gotham text-sm">Devices</span>
					</NavLink>
					<NavLink
						to="/users"
						className="main-nav-item opacity-5 flex-row-left full"
					>
						<i className="nav-icon ri-shield-user-line"></i>
						<span className="text-medium-gotham text-sm">Users</span>
					</NavLink>
					<NavLink
						to="/roles"
						className="main-nav-item opacity-5 flex-row-left full"
					>
						<i className="nav-icon ri-lock-2-line"></i>
						<span className="text-medium-gotham text-sm">Roles</span>
					</NavLink>
					<div className="support-link-container flex-column">
						<div className="support-link p-20 flex-column bg-gray">
							<span className="text-medium-gotham align-center opacity-7">
								Need help?
							</span>
							<span className="text-medium-gotham align-center opacity-7 mb-15">
								Just let us know.
							</span>
							<Button className="support-link-btn btn-default btn-sm btn-rounded text-sm text-medium-gotham full">
								Contact Support
							</Button>
						</div>
					</div>
				</div>
			</div>
			<div className="content">
				<div className="page-header bg-white full flex-row-left">
					<Container className="gx-5">
						<Row className="flex-row-left">
							<Col>
								<div className="header-client">
									<span className="text-medium-gotham text-lg">
										Northern Secondary School
									</span>
								</div>
							</Col>
							<Col className="flex-row-right">
								<Dropdown align="end">
									<Dropdown.Toggle as={CustomToggle}>
										<div
											className="header-user bg-default flex-column"
											style={{
												background: profile?.photo
													? `url(${profile.photo})`
													: "#0d163f",
											}}
										>
											{!profile?.photo && (
												<span
													href="#"
													className="text-medium-gotham text-white text-sm upper"
												>
													{profile?.name[0]}
												</span>
											)}
										</div>
									</Dropdown.Toggle>
									<Dropdown.Menu className="account-dropdown dropdown-default">
										<Dropdown.Item href="/logout" className="text-sm">
											Sign out
										</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>
							</Col>
						</Row>
					</Container>
				</div>
				<Outlet />
			</div>
		</>
	);
};

export default Layout;
